<template>
    <div>
        <div class="flex gap-3 font-semibold mb-3">
            <div class="text-stone-600">
                {{ props.selectData.name }}:
            </div>
            <div>
                {{ props.selectData.items[selectedIndex].name }}
            </div>
        </div>
        <div class="flex gap-3 mb-4">
            <img @click="selectMainProduct(index)" tabindex="0" v-for="(item, index) in props.selectData.items"
                class=" rounded-lg p-1 border-2  max-h-[75px] max-w-[75px] flex-wrap" :src="item.src_img" alt="" :class="{
                    ['border-red-700']: index == selectedIndex,
                    ['border-stone-400 cursor-pointer hover:border-red-400']: index != selectedIndex,
                }" :key="index">
        </div>
        <div>
            <select v-model="selectedProduct" @change="selectProduct" class="select w-full max-w-xs select-bordered">
                <option :value="item" v-for="item in selectedProducts" :key="item.product_id">{{ item.name }}</option>
            </select>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { type SelectProduct, type SelectProductItem } from '@/types/book_item';
import { computed, onMounted, ref } from 'vue';

const props = defineProps<{
    selectData: SelectProduct
}>()


const selectedIndex = computed(() => {
    for (let i = 0; i < props.selectData.items.length; i++) {
        for (let x = 0; x < props.selectData.items[i].items.length; x++) {
            if (props.selectData.items[i].items[x].selected) {
                return i
            }
        }
    }
    return -1000
})

const selectedProducts = computed(() => {
    return props.selectData.items[selectedIndex.value].items ?? []
})

const selectedProduct = ref<SelectProductItem>()

onMounted(() => {
    for (let i = 0; i < props.selectData.items.length; i++) {
        for (let x = 0; x < props.selectData.items[i].items.length; x++) {
            if (props.selectData.items[i].items[x].selected) {
                selectedProduct.value = props.selectData.items[i].items[x]
            }
        }
    }
})

const selectMainProduct = (index: number) => {
    for (let i = 0; i < props.selectData.items[index].items.length; i++) {
        if (props.selectData.items[index].items[i].selected) {
            return
        }
    }
    window.open(props.selectData.items[index].items[0].url, '_self')
}

const selectProduct = () => {
    if (!selectedProduct.value) {
        return
    }
    window.open(selectedProduct.value.url, '_self')
}


</script>